import { render, staticRenderFns } from "./IndexPositions.vue?vue&type=template&id=11647248&"
import script from "./IndexPositions.vue?vue&type=script&lang=js&"
export * from "./IndexPositions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports